// @flow
import React, { useState } from "react";
import { Checkbox, ContextMenu, MenuItem } from "@components";

type MenuItems = $Exact<{
  label: string,
  handler: () => void,
}>;

type Props = $Exact<{
  id: string,
  dropdownItems: Array<MenuItems>,
}>;

export function CheckboxMenu(props: Props) {
  return (
    <ContextMenu align="left" clickTriggerEl={<Checkbox />}>
      {(props.dropdownItems || props.children).map((item, indx) => (
        <MenuItem key={`${item.label}-${indx}`} label={item.label} onClick={item.handler} />
      ))}
    </ContextMenu>
  );
}
